









































































import Vue from "vue";
import AbpBase from "../../lib/abpbase";

export default AbpBase.extend({
  name: "notice",
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.getNotices();
    setInterval(() => {
      this.getNotices();
    }, 60000);
  },
  created() {},
  computed: {
    noticeList: function(): any {
      return Array.isArray(this.$store.state.billing.noticeList) ? this.$store.state.billing.noticeList : [];
    },
    noticeSpinShow: function(): any {
      return this.$store.state.goal.noticeSpinShow || this.$store.state.project.noticeSpinShow;
    },
    unReadCount() {
      return this.noticeList.filter(n => n.read == false).length;
    },
    noticeArray() {
      return this.noticeList.filter(n => n.read == false && n.type === 0);
    },
    noticeCount() {
      return this.noticeList.filter(n => n.read == false && n.type === 0).length;
    },
    messageArray() {
      return this.noticeList.filter(n => n.read == false && n.type === 1);
    },
    messageCount() {
      return this.noticeList.filter(n => n.read == false && n.type === 1).length;
    },
    taskArray() {
      return this.noticeList.filter(n => n.read == false && n.type === 2);
    },
    taskCount() {
      return this.noticeList.filter(n => n.read == false && n.type === 2).length;
    },
    noticeLabel() {
      let name = "Notice";
      if (this.noticeCount > 0) {
        return `${name}(${this.noticeCount})`;
      } else {
        return name;
      }
    },
    messageLabel() {
      let name = "Message";
      if (this.messageCount > 0) {
        return `${name}(${this.messageCount})`;
      } else {
        return name;
      }
    },
    taskLabel() {
      let name = "Task";
      if (this.taskCount > 0) {
        return `${name}(${this.taskCount})`;
      } else {
        return name;
      }
    }
  },
  methods: {
    getNotices() {
      var abp = window.abp;
      if (abp && abp.auth && abp.auth.getToken() !== null && abp.auth.getToken() !== "") {
        this.$store.dispatch("billing/getInviteNotifications");
      }
    },
    handleNoticeClick(notice) {
      if (notice.invitation) {
        var action = notice.invitation.goalName ? "goal/acceptInvitation" : "billing/acceptInvitation";
        this.$store
          .dispatch(action, {
            id: notice.invitation.invitationId,
            token: notice.invitation.token
          })
          .then(response => {
            if (response.data.result.success === true) {
              //location.replace(window.location.origin + abp.appPath);
              location.reload();
            }
          });
      }
    }
  }
});
